import {
  BulkCreatePlannedBreaksDocument,
  BulkCreatePlannedBreaksMutation,
  BulkCreatePlannedBreaksMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useBulkCreatePlannedBreaks = () => {
  const [bulkCreatePlannedBreak, { loading }] = useMutation(BulkCreatePlannedBreaksDocument, {
    extractorFn: (data: BulkCreatePlannedBreaksMutation) =>
      data.timePlanningMutations.bulkCreateTimeplanningPlannedBreak,
  })

  return {
    loading,
    bulkCreate(variables: BulkCreatePlannedBreaksMutationVariables) {
      return bulkCreatePlannedBreak({ variables })
    },
  }
}
